/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Colleague_Filter_All_EngineersInputs */

const en_colleague_filter_all_engineers = /** @type {(inputs: Colleague_Filter_All_EngineersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All field engineers`)
};

const ja_colleague_filter_all_engineers = /** @type {(inputs: Colleague_Filter_All_EngineersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのエンジニア`)
};

const fr_colleague_filter_all_engineers = /** @type {(inputs: Colleague_Filter_All_EngineersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les techniciens`)
};

const de_colleague_filter_all_engineers = /** @type {(inputs: Colleague_Filter_All_EngineersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Techniker`)
};

/**
* | output |
* | --- |
* | "All field engineers" |
*
* @param {Colleague_Filter_All_EngineersInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const colleague_filter_all_engineers = /** @type {((inputs?: Colleague_Filter_All_EngineersInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Colleague_Filter_All_EngineersInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_colleague_filter_all_engineers(inputs)
	if (locale === "ja") return ja_colleague_filter_all_engineers(inputs)
	if (locale === "fr") return fr_colleague_filter_all_engineers(inputs)
	return de_colleague_filter_all_engineers(inputs)
});